import { Env } from '@stencil/core';

const fetchUrl = async (url, key) => {
  try {
    const response = await fetch(url);
    const screenJson = await response.json();
    const screenKeys = ['aiba-welcome-screen', 'aiba-quiz-screen', 'aiba-vto-screen', 'aiba-result-screen', 'aiba-selfie-analysis-failed-screen'];
    if (!screenKeys.includes(key)) {
      return;
    }
    return replaceAssetWithAbsolutePath(screenJson);
  } catch (error) {
    console.error(error);
  }
};

const replaceAssetWithAbsolutePath = (json: any) => {
  let stringifiedJSON = JSON.stringify(json);

  stringifiedJSON = stringifiedJSON.replaceAll('/assets/', `${getAbsolutePath('')}/assets/`);

  return JSON.parse(stringifiedJSON);
};

export const getAbsolutePath = args => {
  let path = Env.BASE_URL ? Env.BASE_URL : '';
  if (!(Env.BASE_URL.split('localhost').length > 1)) {
    path += Env.FEATURE_PATH ? '/' + Env.FEATURE_PATH : '';
    path += Env.BRAND ? '/' + Env.BRAND : '';
    path += Env.LOCALE ? '/' + Env.LOCALE : '';
    let version = Env.VERSION ? Env.VERSION : '';
    path += Env.JOURNEY ? '/' + (Env.JOURNEY.split('-')[0] === 'hair' ? 'vto/' + version : 'vto/' + version) : '';
  }
  return path + args;
};

export const getScreenData = async key => {
  const screenDataMap = {
    'aiba-welcome-screen': 'welcome.json',
    'aiba-quiz-screen': 'quiz.json',
    'aiba-result-screen': 'result.json',
    'aiba-vto-screen': 'vtoScreen.json',
    'aiba-selfie-analysis-failed-screen': 'errorScreen.json',
  };

  const screenDataPath = `${getAbsolutePath('')}/data/${screenDataMap[key]}`;
  return await fetchUrl(screenDataPath, key);
};
